export const meta = {
  id: 'M09',
  slug: 'preparar-mentoria',
  title: 'Como preparar uma Mentoria',
  description: 'Use o contexto disponível no Personagrama para chegar à sessão com foco e perguntas mais úteis.',
  profile: 'mentor',
  category: 'mentorias',
  type: 'task',
  status: 'published',
  order: 300,
  keywords: ['mentoria', 'preparar', 'sessão', 'visão 360', 'evidências', 'acordos', 'progresso'],
  previous: 'M08',
  next: 'M10',
  related: ['M02', 'M07', 'M10'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como preparar uma Mentoria

Antes da sessão, use o Personagrama para recuperar o contexto essencial do mentorado sem transformar a preparação em uma revisão mecânica de dados.

## O que revisar

- objetivo de desenvolvimento;
- competências prioritárias;
- Plano;
- Jornada e Formações;
- progresso recente;
- Evidências relevantes;
- Acordos anteriores;
- pendências que merecem atenção.

## Como preparar

<Steps>
  <Step title="Abra o mentorado">
    Comece pela Visão 360 para recuperar o contexto geral.
  </Step>
  <Step title="Escolha os temas relevantes">
    Identifique os pontos que mais se relacionam ao objetivo e ao momento atual.
  </Step>
  <Step title="Formule perguntas">
    Prepare perguntas que ajudem o mentorado a refletir, decidir e agir.
  </Step>
  <Step title="Entre na sessão com foco">
    Leve prioridades, não uma lista interminável de pendências.
  </Step>
</Steps>

<Callout type="tip">
  O objetivo da preparação não é revisar tudo. É descobrir quais conversas podem gerar mais desenvolvimento nesta sessão.
</Callout>

<HelpImage alt="Preparação de Mentoria a partir da visão do mentorado" pendingId="M09.1" />
